// extracted by mini-css-extract-plugin
module.exports = {"intro":"search_intro__HlJ0J","loadMore":"search_loadMore__FvTYE","headline":"search_headline__2b11U"};